import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/htx/lab-procedures/hgbA1C";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	hgbA1C: {
		id: "form.hgba1v",
		defaultMessage: "HgbA1C"
	},
	value: {
		id: "form.hgba1v.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "hgbA1C",
	value: {
		title: messages.hgbA1C,
		validator,
		fieldset,
		isImportant: true
	}
};
